import { useMemo } from 'react';

export const useExposureParams = () => {
  const params = new URLSearchParams(window.location.search);
  const exposureName = params.get('name');
  const uniqueIdFromUrl = params.get('uniqueId') ?? params.get('uniqueid');
  const environmentIdStr = params.get('environmentId') ?? params.get('environmentid');
  const jobIdStr = params.get('jobId') ?? params.get('jobid');
  const jobId = useMemo((): number => {
    if (jobIdStr) {
      return parseInt(jobIdStr);
    }
    return 0;
  }, [jobIdStr]);
  const environmentIdFromUrl = useMemo((): number => {
    if (environmentIdStr) {
      return parseInt(environmentIdStr);
    }
    return 0;
  }, [environmentIdStr]);

  if (exposureName && jobId) {
    return {
      environmentId: undefined,
      uniqueId: undefined,
      environmentType: undefined,
      exposureName,
      jobId,
    } as const;
  }

  const environmentId = environmentIdFromUrl;
  const uniqueId = uniqueIdFromUrl;
  const environmentType = (params.get('environmentType') ??
    params.get('environmenttype') ??
    'production') as 'production' | 'staging'; // | 'development';
  const autoBiProvider = params.get('autoBiProvider') ?? params.get('autobiprovider');
  const biResourceId = params.get('biResourceId') ?? params.get('biresourceid');
  return {
    jobId: undefined,
    exposureName: undefined,
    environmentId,
    uniqueId,
    environmentType,
    autoBiProvider,
    biResourceId,
  } as const;
};
